import { AutopilotSidebar as BaseAutopilotSidebar } from 'screens/VirtualMarketerOnboarding/AutopilotSidebar/AutopilotSidebar'

export const AutopilotSidebar = () => {
  return (
    <BaseAutopilotSidebar
      sections={[
        {
          heading: 'Say goodbye to copy/paste',
          text: 'Connect your accounts and save 5+ hours per week through automatic posting.',
        },
        {
          heading: 'Connection issues?',
          text: 'Our support team resolves 95% of issues in under 3 minutes via the help button below.',
        },
      ]}
    />
  )
}
